import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { SiaTranslatePipe } from '@sia/shared';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';

@Component({
  selector: 'sia-check-box-date',
  templateUrl: './sia-check-box-date.component.html',
  styleUrls: ['./sia-check-box-date.component.scss'],
  standalone: true,
  imports: [MatCheckbox, FormsModule, SiaTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaCheckBoxDateComponent extends SiaBaseEditorSignalComponent {
  checked = signal(false);

  protected override onInternalValueSet(newValue: any): any {
    const normalized = newValue ?? null;
    this.checked.set(!!normalized);
    return normalized;
  }

  onCheckedChange(isChecked: boolean) {
    if (this.isDisabled()) {
      return;
    }
    this.value.set(isChecked ? new Date() : null);
  }

  changeValue() {
    this.onCheckedChange(!this.checked());
  }
}
